module.exports = __webpack_public_path__ + "static/media/icon_23.3b912766.svg";